import loadable from '@loadable/component';
import { useState } from 'react';
import Skeleton from '../components/Reusable/Skeleton';
import APIS from '../constant/EndPoint';
import useGetHook from '../customHooks/useGetHook';
import usePostHook from '../customHooks/usePostHook';
import { queryClient } from '../router';

const OverViewComponent = loadable(() => import('../components/Overview'));

const OverView = () => {
  const [selectedItem, setSelectedItem] = useState<any>(null);

  const {
    data: gridData,
    isLoading,
    refetch,
  } = useGetHook({
    queryKey: [`grid-data`],
    url: `${APIS.GRID_REPORT_DATA}`,
    params: {
      parent__slug: 'merchant',
    },
  });

  const { data: draftOrder, isLoading: isDataLoading } = useGetHook({
    queryKey: [`draft-order`],
    url: `${APIS.DRAFT_ORDER}`,
    params: {},
  });
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ['cache-clear'],
  });

  const handleClearCache = async () => {
    const url = `${APIS.CACHE}`;
    const formData = {
      name: 'logistic_overview,overview',
    };
    try {
      const res = await mutateAsync({ url, formData });
      if (res?.status === 200) {
        refetch();
        const queriesToInvalidate = ['status', 'merchant-overview'];
        queriesToInvalidate.forEach((key) => {
          queryClient.invalidateQueries({
            queryKey: [key],
            refetchType: 'active',
          });
        });
      }
    } catch (err) {
      console.error(err);
    }
  };

  return isLoading ? (
    <Skeleton />
  ) : (
    <OverViewComponent
      gridData={gridData}
      draftOrder={draftOrder}
      setSelectedItem={setSelectedItem}
      handleClearCache={handleClearCache}
      isLoading={isPostLoading}
    />
  );
};

export default OverView;
